const STORAGE_KEY = "pos_loyalty_provisional_v1";

type ProvisionalEntry = {
  branchId: string;
  customerId: string;
  clientOrderId: string;
  points: number;
};

function readEntries(): ProvisionalEntry[] {
  if (typeof sessionStorage === "undefined") return [];
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as ProvisionalEntry[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeEntries(entries: ProvisionalEntry[]): void {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
}

export function addProvisionalLoyaltyRedemption(input: {
  branchId: string;
  customerId: string;
  clientOrderId: string;
  points: number;
}): void {
  const entries = readEntries().filter(
    (e) => e.clientOrderId !== input.clientOrderId,
  );
  entries.push({
    branchId: input.branchId,
    customerId: input.customerId,
    clientOrderId: input.clientOrderId,
    points: input.points,
  });
  writeEntries(entries);
}

export function removeProvisionalLoyaltyRedemption(
  clientOrderId: string,
): void {
  writeEntries(readEntries().filter((e) => e.clientOrderId !== clientOrderId));
}

export function getProvisionalLoyaltyPoints(
  branchId: string,
  customerId: string,
): number {
  return readEntries()
    .filter(
      (e) => e.branchId === branchId && e.customerId === customerId,
    )
    .reduce((sum, e) => sum + e.points, 0);
}

export function getEffectiveLoyaltyBalanceFromCache(
  cachedBalance: number | undefined,
  branchId: string,
  customerId: string,
): number {
  const base = cachedBalance ?? 0;
  const held = getProvisionalLoyaltyPoints(branchId, customerId);
  return Math.max(0, Math.round((base - held) * 100) / 100);
}
